module.exports = __webpack_public_path__ + "img/no-photo.a15ca7c5.webp";